import React from "react";
import { DataSection } from "../components";

const fields = [
  { key: "title", label: "Risiko", type: "text" },
  { key: "category", label: "Kategorie", type: "select", options: ["Strategie", "Operativ", "IT", "Finanzen", "Liquidität", "Compliance", "HR"] },
  { key: "likelihood", label: "Eintritt", type: "select", options: ["niedrig", "mittel", "hoch"] },
  { key: "impact", label: "Auswirkung", type: "select", options: ["niedrig", "mittel", "hoch"] },
  { key: "severity", label: "Schweregrad", type: "select", options: ["low", "medium", "high"], badge: true },
  { key: "owner", label: "Owner", type: "text" },
  { key: "status", label: "Status", type: "select", options: ["offen", "in Bearbeitung", "beobachtet", "erledigt"], badge: true },
  { key: "mitigation", label: "Massnahmen", type: "textarea", table: false },
  { key: "due_date", label: "Frist", type: "date" },
];

const Risks = () => <DataSection overline="GRC" title="Risiko-Register" entity="risks" fields={fields} />;
export default Risks;
